// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13XXP","buttons":"styles_buttons__yzDv0"};